// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export class AutoTestFixture {
    id;
    name;
    hidden;
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    constructor(id, name, hidden) {
        this.id = id;
        this.name = name;
        this.hidden = hidden;
        Object.freeze(this);
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    static fromServerData(data) {
        return new AutoTestFixture(data.id, data.name, data.hidden);
    }
}
